import useTranslations from "@/shared/lang/useTranslations";

import { DEPOSIT_CLABES_CORRIDOR } from "../services/depositAccounts.service";
import { DepositAccountsPage } from "./DepositAccountsPage";

/**
 * `/app/payments-config/deposit-clabes` — INTERNAL staff config of the Mexico SPEI receiving CLABEs. Thin
 * binding of the generic `DepositAccountsPage` to the CLABEs corridor.
 */
const DepositClabesPage = () => {
  const { t: tGlobal } = useTranslations("global");
  return (
    <DepositAccountsPage
      corridor={DEPOSIT_CLABES_CORRIDOR}
      breadcrumbLabel={tGlobal("sidebar_menu_deposit_clabes")}
      route="/app/payments-config/deposit-clabes"
    />
  );
};

export default DepositClabesPage;
